import { useCheckPermissions } from "@/shared";
import SaveCargosPage from "../../shared/saveCargos/saveCargos";
import { PermissionsEnum } from "@/auth/interfaces";


export interface CreateCargosPageInterface {}

const CreateCargosPage: React.FC<CreateCargosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_cargo)

  return <SaveCargosPage titlePage="Crear Cargos
  " />;
};

export default CreateCargosPage;
